import CreditCardIcon from '@material-ui/icons/CreditCard';

import List from './List2';

export default {
  list: List,
  icon: CreditCardIcon,
};
